import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { MoreVertical } from 'lucide-react';
import CategoryOptionsMenu from '../Menus/CategoryOptionsMenu';
import EditCategoryModal from '../Modals/EditCategoryModal';

const CategoryCard = ({ category, onEdit, onDelete }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    const handleMenuItemClick = (action) => {
        if (action === "editCategory") {
            setIsEditModalOpen(true);
        } else if (action === "deleteCategory") {
            onDelete(category.id);
        }
    };

    return (
        <Card className="w-full">
            <CardHeader>
                <div className="flex items-center justify-between">
                    <CardTitle>{category.name}</CardTitle>
                    <div className="relative">
                        <Button
                            variant="ghost"
                            size="icon"
                            onClick={() => setMenuOpen(!menuOpen)}
                            className="h-8 w-8"
                        >
                            <MoreVertical className="h-4 w-4" />
                        </Button>
                        <CategoryOptionsMenu
                            isOpen={menuOpen}
                            onSelect={handleMenuItemClick}
                            onClose={() => setMenuOpen(false)}
                        />
                    </div>
                </div>
            </CardHeader>
            <EditCategoryModal
                isOpen={isEditModalOpen}
                onClose={() => setIsEditModalOpen(false)}
                category={category}
            />
        </Card>
    );
};

export default CategoryCard; 